var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDraftLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C10.2761 1 10.5 1.22386 10.5 1.5V3.3785L9.5 4.3785V2H2.5V10H9.5V8.621L10.5 7.621V10.5C10.5 10.7761 10.2761 11 10 11H2C1.72386 11 1.5 10.7761 1.5 10.5V1.5C1.5 1.22386 1.72386 1 2 1H10ZM10.8891 4.4038L11.5962 5.1109L7.7071 9L6.99895 8.99895L7 8.2929L10.8891 4.4038ZM6.5 6V7H4V6H6.5ZM8 4V5H4V4H8Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDraftLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DraftLine.f88a283a.svg";
export { ForwardRef as ReactComponent };